import { render, staticRenderFns } from "./ObjectsListGroup.vue?vue&type=template&id=24241cb1&"
import script from "./ObjectsListGroup.vue?vue&type=script&lang=js&"
export * from "./ObjectsListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports